<script>
import {defineComponent} from 'vue'
import {ElNotification} from "element-plus";


export default defineComponent({
  name: "InitiativeCategoryForm",
  data() {
    return {
      loading: false,
      form: {
        id: null,
        title: null
      },
      rules: {
        title: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
      }
    }
  },
  methods: {
    getCategoryById() {
      this.loading = true;
      this.$http
          .get(`/api/v1/initiative-categories/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;

          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/initiative-categories/${this.form.id}`, this.form);
          } else {
            http = this.$http.post("/api/v1/initiative-categories", this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getCategoryById();
    }
  }
})
</script>

<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Nomini kiriting" prop="title">
                <el-input type="textarea" rows="6" v-model="form.title"/>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.images {
  columns: 3;

  .image-item {
    position: relative;

    :deep(el-image) {
      border: 1px solid #e4e4e4;
    }
  }
}
</style>
